import { render } from "./ContentsArea.vue?vue&type=template&id=85b22ee4"
import script from "./ContentsArea.vue?vue&type=script&lang=js"
export * from "./ContentsArea.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__